module.exports = __webpack_public_path__ + "static/distributor-50416cf2df299b59b7d13c5247f2dcb0.webp";